import { receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const FETCH_SYNC_INFO_SUCCESS = 'FETCH_SYNC_INFO_SUCCESS'
export const FETCH_SYNC_INFO_ERROR   = 'FETCH_SYNC_INFO_ERROR'

export function fetchSyncInfo() {
  return (dispatch, getState) => {
    CloudFlyerAPI
      .user_account
      .fetchSyncInfoAll()
      .then(({ data }) => {
        dispatch(receiveData(FETCH_SYNC_INFO_SUCCESS, data))
      })
      .catch(err => {
        dispatch(receiveError(FETCH_SYNC_INFO_ERROR, err))
      })
  }
}
